export default function SizzhkaLoader({ size = "default" }) {
  const isSmall = size === "small";
  
  return (
    <div className={`flex items-center justify-center ${isSmall ? "" : "h-[60vh]"}`} data-testid="loader">
      <div className="flex flex-col items-center gap-3">
        {/* Animated bars — brutalist style */}
        <div className="flex items-end gap-[3px]">
          {[0, 1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="w-[3px] bg-white origin-bottom"
              style={{
                animation: `szLoader 1s ease-in-out ${i * 0.12}s infinite`,
                height: isSmall ? "16px" : "24px",
              }}
            />
          ))}
        </div>
        {!isSmall && (
          <span className="text-[10px] font-mono text-zinc-600 tracking-[0.3em] animate-pulse">
            LOADING
          </span>
        )}
      </div>
    </div>
  );
}
